import { render, staticRenderFns } from "./edit.chat-messages.page.vue?vue&type=template&id=459215c6&"
import script from "./edit.chat-messages.page.vue?vue&type=script&lang=js&"
export * from "./edit.chat-messages.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports